import React, { useCallback } from 'react';

import { useAuth } from 'hooks/useAuth';
import { useResponsiveScreenSizes } from 'hooks/useResponsiveScreenSizes';

import { colors, ColorsTransparencies, Fonts, spacing } from 'styles/theme';
import {
    Bumper,
    HorizontalFlexWrapper,
    PointerEventWrapper,
} from 'styles/shared';
import { Link } from 'react-router-dom';

export interface FooterProps {
    hasSignOut: boolean;
    $textColor: ColorsTransparencies;
}

export const Footer = ({ hasSignOut, $textColor }: FooterProps) => {
    const { signOut } = useAuth();
    const { isMobileScreenSize } = useResponsiveScreenSizes();

    const onSignOut = useCallback(() => {
        signOut?.();
    }, [signOut]);

    const calculatedTextColor = isMobileScreenSize ? colors.grey30 : $textColor;

    return (
        <HorizontalFlexWrapper $isContentSpread $isVerticalOnMobile>
            <Fonts.XSmall $color={calculatedTextColor}>
                {`© The Grand, Inc. 2025`}
            </Fonts.XSmall>
            <HorizontalFlexWrapper $isVerticalOnMobile>
                <Bumper $minWidth={spacing.xxxLarge} />
                <PointerEventWrapper>
                    <Link
                        to="https://www.thegrand.world/termsofservice"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Fonts.XSmall
                            $color={calculatedTextColor}
                            $isUnderlined
                        >
                            {`Terms of Service`}
                        </Fonts.XSmall>
                    </Link>
                </PointerEventWrapper>
                <Bumper $minWidth={spacing.xxxLarge} />
                <PointerEventWrapper>
                    <Link
                        to="https://www.thegrand.world/privacypolicy"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Fonts.XSmall
                            $color={calculatedTextColor}
                            $isUnderlined
                        >
                            {`Privacy Policy`}
                        </Fonts.XSmall>
                    </Link>
                </PointerEventWrapper>
                {hasSignOut ? (
                    <>
                        <Bumper $minWidth={spacing.xxxLarge} />
                        <PointerEventWrapper>
                            <Link to="/sign-in" onClick={onSignOut}>
                                <Fonts.XSmall
                                    $color={calculatedTextColor}
                                    $isUnderlined
                                >
                                    {`Log Out`}
                                </Fonts.XSmall>
                            </Link>
                        </PointerEventWrapper>
                    </>
                ) : null}
            </HorizontalFlexWrapper>

            <Bumper $minHeight={spacing.xxxLarge} $shouldHideOnDesktop />
            <Bumper $minHeight={spacing.xxxLarge} $shouldHideOnDesktop />
        </HorizontalFlexWrapper>
    );
};
